module.exports = __webpack_public_path__ + "assets/media/morning.43af49c2.mp3";